import React from 'react';
import { GrantDTO } from '../../../../Profile/Accounts/api/useAccountsQuery';
import { TableRow } from '../TableRow/TableRow';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatNumber } from '../../../../CommonUtils/formatNumber';

interface Props {
  grant: GrantDTO;
}

export const VestingListTable = ({ grant }: Props) => {
  if ((grant.VestingList || []).length === 0) {
    return null;
  }

  return (
    <table>
      <thead>
        <tr>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Vest Year
            </Text>
          </th>
          <th>
            <Text variant="smallCaps" textAlign="right">
              Shares Vested
            </Text>
          </th>
          <th>
            <Text variant="smallCaps" textAlign="right">
              Shares Owned
            </Text>
          </th>
        </tr>
      </thead>

      <tbody>
        {grant.VestingList.map(vest => (
          <TableRow key={vest.Id}>
            <td>
              <Text fontWeight={500} textAlign="left">
                {vest.VestingYear}
              </Text>
            </td>
            <td>
              <Text variant="tabular" fontWeight={500} textAlign="right">
                {formatNumber(vest.VestedShares)}
              </Text>
            </td>
            <td>
              <Text variant="tabular" fontWeight={500} textAlign="right">
                {formatNumber(vest.SharesOwned)}
              </Text>
            </td>
          </TableRow>
        ))}
      </tbody>
    </table>
  );
};
